exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AutoSave_checkboxs_pOk3F{\n    display: none;\n}\n.AutoSave_checkbox-label_1TM_6{\n    cursor: pointer;\n}\n.AutoSave_checkbox-label_1TM_6:before{\n    width: 1rem;\n    height: 1rem;\n    content: \" \";\n    display: inline-block;\n    background-size: 100% 100%;\n    background-position: center center;\n    background-repeat: no-repeat;\n    vertical-align: middle;\n    margin-right: .1rem;\n}\n.AutoSave_checkboxs_pOk3F:checked+label:before{\n\n}\n", ""]);

// exports
exports.locals = {
	"checkboxs": "AutoSave_checkboxs_pOk3F",
	"checkbox-label": "AutoSave_checkbox-label_1TM_6",
	"checkboxLabel": "AutoSave_checkbox-label_1TM_6"
};